var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var _a;
var baseConfig = {
  eventNotification: {},
  //Leaving this null for now, unused at any facility but should be built to support,
  name: '',
  // We load this value upon loading a facility
  timezone: 'America/Chicago',
  // Default to America/Chicago but change when we load the facility
  nodeServer: process.env.NODE_SERVER,
  api: {
    url: (_a = process.env.SITE_API_URL) !== null && _a !== void 0 ? _a : location.origin + '/api-site'
  },
  centralApi: {
    url: process.env.CENTRAL_API_URL
  },
  auth: {
    clientId: 'relcore-site',
    accessTokenUri: process.env.CENTRAL_API_URL,
    clientSecret: ''
  },
  features: [],
  sip: {
    host: 'window.location.hostname',
    // Username and password are unimportant since session ID header will be used for auth
    user: 'rwis',
    password: '',
    wsServers: (location.protocol === 'https:' ? 'wss://' : 'ws://') + window.location.hostname + '/opensips'
  },
  connectServer: {
    url: null
  },
  phpDateFormat: 'YYYY-MM-DD HH:mm:ss',
  urlDateFormat: 'YYYYMMDD_HHmmss',
  urlDateRegex: /\d{8}_\d{6}/,
  inmate: {
    itdsEnabled: false,
    // Enable ITDS features
    housingUnitsEnabled: false,
    pinLength: 6,
    purchaseItems: [{
      cost: 3,
      title: 'Headphones',
      transactionDescription: 'Replacement headphones'
    }]
  },
  privateNumber: {
    readOnly: false
  },
  visitation: {
    timeLimitOptions: [15, 30, 60],
    defaultTimeLimit: 30,
    visitationVisitorOptionalFields: []
  },
  search: {
    defaultStartDatePeriod: -1,
    outbound: {
      defaultMinDuration: 0,
      defaultMaxDuration: null,
      startDatePeriod: 1,
      // Options: Destination, PhoneCard, Inmate
      criteriaChoices: ['Destination', 'PhoneCard', 'Inmate'],
      // One of the above criteriaChoices options
      defaultCriteriaChoice: 'Destination',
      callTypes: {
        'audio-call': 'Audio',
        'video-call': 'Video'
      },
      defaultCallTypes: ['audio-call', 'video-call']
    },
    inbound: {
      startDatePeriod: 1,
      source: 'central'
    },
    visitation: {
      startDatePeriod: 1,
      defaultMinDuration: 60
    }
  }
};
var config = __assign(__assign({}, baseConfig), {
  hasFeature: function hasFeature(feature) {
    return (this.features || []).indexOf(feature) > -1;
  },
  hasOneOfFeatures: function hasOneOfFeatures(features) {
    var _this = this;
    return features.reduce(function (prev, cur) {
      return prev || _this.hasFeature(cur);
    }, false);
  }
});
export default config;